"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServicesList = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var ButtonPrim_1 = require("components/Buttons/ButtonPrim");
var ButtonsHolder_1 = __importDefault(require("components/Buttons/ButtonsHolder"));
var Main_1 = __importDefault(require("components/Layout/Main"));
var BasicListContent_1 = __importDefault(require("components/Lists/BasicListContent"));
var BasicListResults_1 = __importDefault(require("components/Lists/BasicListResults"));
var BasicListWrapper_1 = __importDefault(require("components/Lists/BasicListWrapper"));
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var HudledHelmet_1 = __importDefault(require("containers/App/HudledHelmet"));
var HoCs_1 = require("utils/HoCs");
var ordered_1 = require("utils/selectors/ordered");
var AdminReferenceRow_1 = __importDefault(require("./AdminReferenceRow"));
var AdminReferencesListHeader_1 = __importDefault(require("./AdminReferencesListHeader"));
var RANGES = [
    { label: '#-P', end: 'P' },
    { label: 'P-Z', start: 'P', end: 'Z' },
    { label: 'a-p', start: 'a', end: 'p' },
    { label: 'p-...', start: 'p' },
];
var FILTER_FUNCTIONS = {
    noPatterns: function (ref) { return !ref.rePattern && !ref.keyword; },
    noService: function (ref) { return !ref.serviceId; },
};
function ServicesList() {
    var _a = __read(react_1.default.useState(null), 2), feFilter = _a[0], setFeFilter = _a[1];
    var _b = __read(react_1.default.useState(''), 2), searchString = _b[0], setSearchString = _b[1];
    var _c = __read(react_1.default.useState(RANGES[0]), 2), range = _c[0], setRange = _c[1];
    (0, react_redux_firebase_1.useFirestoreConnect)(function () { return [{
            collection: 'references',
            where: [
                range.start && ['reference', '>=', range.start],
                range.end && ['reference', '<', range.end],
            ].filter(end2end_1.notFalsy),
        }]; });
    var referencesArray = (0, react_redux_1.useSelector)(ordered_1.selectReferences);
    var servicesArray = (0, react_redux_1.useSelector)(ordered_1.selectServices);
    var preFilteredReferencesArray = feFilter ? referencesArray === null || referencesArray === void 0 ? void 0 : referencesArray.filter(FILTER_FUNCTIONS[feFilter]) : referencesArray;
    var filteredReferencesArray = searchString
        ? preFilteredReferencesArray === null || preFilteredReferencesArray === void 0 ? void 0 : preFilteredReferencesArray.filter(function (ref) { var _a; return (_a = ref.reference) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchString.toLowerCase()); })
        : preFilteredReferencesArray;
    if (!referencesArray || !(0, react_redux_firebase_1.isLoaded)(referencesArray)) {
        return (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(HudledHelmet_1.default, { title: "ServicesList", description: "Description of ServicesList" }), (0, jsx_runtime_1.jsxs)(Main_1.default, { children: [(0, jsx_runtime_1.jsxs)(ButtonsHolder_1.default, { children: [(0, jsx_runtime_1.jsx)(ButtonPrim_1.ButtonPrim, __assign({ disabled: feFilter === 'noPatterns', onClick: function () { return setFeFilter('noPatterns'); } }, { children: "Without Keyword or Pattern" })), (0, jsx_runtime_1.jsx)(ButtonPrim_1.ButtonPrim, __assign({ disabled: feFilter === 'noService', onClick: function () { return setFeFilter('noService'); } }, { children: "Without Hudled Service" })), (0, jsx_runtime_1.jsx)(ButtonPrim_1.ButtonPrim, __assign({ disabled: feFilter === null, onClick: function () { return setFeFilter(null); } }, { children: "Show All" }))] }), (0, jsx_runtime_1.jsxs)(ButtonsHolder_1.default, __assign({ className: "mt-1 mb-1" }, { children: [RANGES.map(function (rangeOpt) { return ((0, jsx_runtime_1.jsx)(ButtonPrim_1.ButtonPrim, __assign({ disabled: ['start', 'end'].every(function (k) { return range[k] === rangeOpt[k]; }), onClick: function () { return setRange(rangeOpt); } }, { children: rangeOpt.label }), rangeOpt.label)); }), (0, jsx_runtime_1.jsx)("label", __assign({ htmlFor: "searchRef" }, { children: "Search:" })), (0, jsx_runtime_1.jsx)("input", { id: "searchRef", onChange: function (e) { return setSearchString(e.target.value); }, value: searchString, placeholder: "search..." })] })), (0, jsx_runtime_1.jsxs)(BasicListWrapper_1.default, { children: [(0, jsx_runtime_1.jsx)(AdminReferencesListHeader_1.default, {}), (0, jsx_runtime_1.jsx)(BasicListContent_1.default, { children: (0, jsx_runtime_1.jsx)(BasicListResults_1.default, { component: AdminReferenceRow_1.default, items: filteredReferencesArray, rowProps: { services: servicesArray } }) })] })] })] }));
}
exports.ServicesList = ServicesList;
exports.default = react_1.default.memo((0, HoCs_1.AuthHoC)(ServicesList));
